@if (show) {
  <div class="fullscreen-alert">
    <div class="custom-alert" color="bg-success">
      <div class="custom-alert-content">
        <form>
          
          <p class="alert-text">{{ message }}</p>

          <div class="d-flex justify-content-end">
            @if (showCancel || showConfirm) {
              <div class="d-flex justify-content-end w-100">
                @if (showCancel) {
                  <button
                    (click)="close()"
                    mat-stroked-button
                    color="warn"
                    class="button cancel"
                  >
                    Cancelar
                  </button>
                }
                @if (showConfirm) {
                  <button
                    (click)="confirm()"
                    class="button change-profile cardWithShadow"
                  >
                    Confirmar
                  </button>
                }
              </div>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
}
